import React from 'react';
import { Hero } from './components/sections/Hero';
import { ProblemSolution } from './components/sections/ProblemSolution';
import { HowItWorks } from './components/sections/HowItWorks';
import { Testimonials } from './components/sections/Testimonials';
import { ExpertEndorsement } from './components/sections/ExpertEndorsement';
import { OfferBonuses } from './components/sections/OfferBonuses';
import { Guarantee } from './components/sections/Guarantee';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { SalesNotification } from './components/ui/SalesNotification';
import { PerformanceOptimizer } from './components/PerformanceOptimizer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#D4AF37] selection:text-white" data-id="element-0">
      <PerformanceOptimizer data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSolution data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <Testimonials data-id="element-6" />
        <ExpertEndorsement data-id="element-7" />
        <OfferBonuses data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <SalesNotification data-id="element-12" />
    </div>;
}